/* ZDHOBA compare drag interaction repair 2026-10-29 */
(function () {
  function initZdCompareDrag() {
    var sliders = document.querySelectorAll('#zdv2 .zd-compare[data-zd-compare]');
    sliders.forEach(function (slider) {
      if (slider.dataset.zdCompareDragReady === '1') return;
      var handle = slider.querySelector('[data-zd-compare-handle]');
      if (!handle) return;
      var activePointerId = null;
      function setPositionFromClientX(clientX) {
        var rect = slider.getBoundingClientRect();
        if (!rect.width) return;
        var percent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        slider.style.setProperty('--compare-position', percent.toFixed(2) + '%');
        handle.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        activePointerId = event.pointerId;
        setPositionFromClientX(event.clientX);
        try { if (slider.setPointerCapture) slider.setPointerCapture(event.pointerId); } catch (error) {}
        slider.classList.add('is-dragging');
        try { handle.focus({ preventScroll: true }); } catch (error) { handle.focus(); }
        if (event.cancelable) event.preventDefault();
      }
      function onPointerMove(event) {
        if (activePointerId !== event.pointerId) return;
        setPositionFromClientX(event.clientX);
        if (event.cancelable) event.preventDefault();
      }
      function onPointerEnd(event) {
        if (activePointerId !== event.pointerId) return;
        activePointerId = null;
        slider.classList.remove('is-dragging');
        try {
          if (slider.hasPointerCapture && slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }
      slider.addEventListener('pointerdown', onPointerDown);
      slider.addEventListener('pointermove', onPointerMove);
      slider.addEventListener('pointerup', onPointerEnd);
      slider.addEventListener('pointercancel', onPointerEnd);
      slider.addEventListener('lostpointercapture', function (event) {
        if (activePointerId === event.pointerId) {
          activePointerId = null;
          slider.classList.remove('is-dragging');
        }
      });
      handle.addEventListener('keydown', function (event) {
        var current = parseFloat(handle.getAttribute('aria-valuenow') || '50');
        var next = current;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next -= event.shiftKey ? 10 : 2;
        else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next += event.shiftKey ? 10 : 2;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = 100;
        else return;
        event.preventDefault();
        next = Math.max(0, Math.min(100, next));
        slider.style.setProperty('--compare-position', next + '%');
        handle.setAttribute('aria-valuenow', String(Math.round(next)));
      });
      slider.dataset.zdCompareDragReady = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZdCompareDrag, { once: true });
  else initZdCompareDrag();
  document.addEventListener('shopify:section:load', initZdCompareDrag);
})();